import { useEffect } from 'react';
import DefaultProfile from '../../assets/images/profile.png';
import { useLazyGetLeaveAndRegularizationRequestsQuery } from '../../features/apis/authApi';
function getStatusClasses(status) {
  switch (status) {
    case 'approved':
      return 'bg-[#CBF6D5]';
    case 'pending':
      return 'bg-yellow-100 ';
    case 'rejected':
      return 'bg-red-100 ';
    default:
      return 'bg-gray-100 ';
  }
}
function LeaveRegularise() {
  const [getRequests, { data }] =
    useLazyGetLeaveAndRegularizationRequestsQuery();
  console.log(data);
  const getFormattedDateTime = () => {
    const now = new Date();
    const datePart = now.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }); // e.g., 12 Apr 2025

    const timePart = now.toLocaleTimeString('en-IN', {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZoneName: 'short',
    });

    return `${datePart}, ${timePart}`;
  };

  useEffect(() => {
    getRequests();
  }, [getRequests]);
  return (
    <div className="flex justify-between items-stretch gap-4 flex-col md:flex-row">
      <div className="bg-white w-full md:w-1/2 px-6 pt-3 rounded-md">
        <h2 className="text-base font-inter font-bold my-1">Leave Requests</h2>

        <p className="text-[#B9B9B9] text-[8px]">
          Last Updated : {getFormattedDateTime()}
        </p>

        <div className="my-2 h-[0.5px] bg-[#D4D4D4]" />
        <div className="flex-1 h-[200px] overflow-y-auto overflow-x-auto hide-scrollbar py-2 font-inter">
          {data?.data?.leaveRequests?.map((req) => (
            <div className="min-w-max grid grid-cols-3 pt-2">
              {/* LEFT */}
              <div className="flex items-center gap-1">
                <img
                  src={req.avatar || DefaultProfile}
                  className="h-9 w-9 rounded-full"
                />

                <p className="text-xs flex flex-col">
                  <span>
                    {req.name.split(' ')[0]} {req.name.split(' ')[1]?.charAt(0)}
                    .
                  </span>
                  <span className="text-[#6E3EF5] text-[10px]">{req.date}</span>
                </p>
              </div>

              {/* MIDDLE */}
              <div className="flex flex-col">
                <span className="capitalize text-xs">{req.leaveType}</span>

                <span className="text-[10px] text-[#B9B9B9] pr-3 capitalize">
                  {req.reason?.length > 20
                    ? req.reason.slice(0, 20) + '...'
                    : req.reason}
                </span>
              </div>

              {/* RIGHT */}
              <div className="text-[10px] flex items-center justify-center">
                <span
                  className={`px-2 py-1 rounded capitalize ${getStatusClasses(
                    req.status
                  )}`}
                >
                  {req.status.charAt(0).toUpperCase() +
                    req.status.slice(1).toLowerCase()}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-white w-full md:w-1/2 p-6 rounded-md ml-2">
        <h2 className="text-base  mb-4 font-inter font-bold">
          Regularization Requests
        </h2>
        <div className="my-3 h-[0.5px] bg-[#D4D4D4]" />{' '}
        <div className="flex-1 h-[200px] overflow-y-auto hide-scrollbar  font-inter overflow-x-auto">
          {data?.data?.regularizationRequests?.map((req) => (
            <div className="min-w-max grid grid-cols-3 pt-2 gap-2">
              <div className="flex items-center gap-1">
                <img
                  src={req.avatar || DefaultProfile}
                  className="h-10 w-10 rounded-full"
                />
                <p className="text-xs  flex flex-col  justify-center ">
                  <span>
                    {req.name.split(' ')[0]} {req.name.split(' ')[1]?.charAt(0)}
                    .
                  </span>{' '}
                  <span className="text-[#707070] text-[9px]">
                    {req.designation?.split(' ').slice(0, 2).join(' ')}
                  </span>
                </p>
              </div>
              <div className="text-[10px] capitalize text-gray-600">
                {req.reason?.length > 30
                  ? req.reason.slice(0, 30) + '...'
                  : req.reason}
              </div>
              <div className="text-[10px] flex flex-col gap-1">
                <span className="text-[#6E3EF5]">{req.date}</span>
                <span className=" text-[#625F6B]">{req.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LeaveRegularise;
